import BaseModel from '../core/BaseModel'
//import gql from 'graphql-tag'
export default class KindInBoxModel extends BaseModel {

    constructor() {
        super({
                name: "kind_in_box",
                tableName: 'kind_in_box',
                label: "Cua trong hộp import",
                display_key: 'name',
                default_order: { key: 'created_at', direction: 'asc' }
            },
            {
                stt: {
                    name: "stt",
                    label: "STT",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                    // display: { list: true, add: false, edit: false }
                },
                id: {
                    name: 'id', 
                    type: "Uuid", 
                    label: 'ID', 
                    primaryKey: true, 
                    display: false
                },
                obj_box: { 
                    name: 'obj_box',
                    type: "String",
                    label: 'Tên chủng loại'
                },
                kind_id: { 
                    name: 'kind_id',
                    type: "String",
                    label: 'Tên chủng loại'
                },
                number: { 
                    name: 'number',
                    type: "Number",
                    label: 'Tên chủng loại'
                },
                weight: { 
                    name: 'weight',
                    type: "Number",
                    label: 'Tên chủng loại'
                },
                exported: { 
                    name: 'exported',
                    type: "Boolean",
                    label: 'Tên chủng loại'
                },
                created_at: {
                    name: 'created_at',
                    type: "Datetime",
                    label: 'Ngày cập nhật',
                    filter: {
                        type: "DateRange", match: "contrains",
                    },
                },

            },
            )
    }

}